import React from 'react';

const Footer = () => {
  return <footer className="footer">Bikerentalmap 2019</footer>;
};

export default Footer;
